import React, { useEffect, useState } from 'react';
import axios from "axios";
import moment from 'moment';
import { BASE_URL } from "../../config";
import StripePaymentTraining from './StripePayment';
import arrowBack from "../../assets/images/arrow-back-icon.svg";
import videoOctagon from "../../assets/images/video-octagon-icon.svg";
import { useNavigate } from 'react-router-dom';
import { loadStripe } from "@stripe/stripe-js";
import authStorage from "../../utils/authStorage";

const PersonalAppTraining = ({back}) => {
    const [showPaymentForm, setShowPaymentForm] = useState(false);
    const [loading, setLoading] = useState(true); 
    const [sesno, setSesno] = useState(false); 
    const [receiptUrl, setReceiptUrl] = useState('');
    const [bookedTrainningSession, setBookedTrainningSession] = useState([]);
    const [showBookedTrainningSession, setShowBookedTrainningSession] = useState(true);
    const [selectedRow, setSelectedRow] = useState(false);
    const[chrgeData,setChrgeData]=useState();
    const [selectedPrice, setSelectedPrice] = useState(null);
    const [selectedSession, setSelectedSession] = useState(null);
    const [selectedTitle, setSelectedTitle] = useState("");
    const [traningSessionDetail, setTraningSessionDetail] = useState({
        total: 0,
        booked: 0
    });

    const stripePromise = loadStripe("pk_test_51N66M3SD7QKOKH3BjS6sufqdUyjfq1jiM8bsm5AerUAHUIoJOatJw0LEhc2WBNtv3lqp13mkXQaMtZkR19aDEk3t001hb1ZdmK");
 
    useEffect(() => {
        let subscribedStatus = authStorage.getItem('subscribedStatus');
            
        // If subscribedStatus is falsy, redirect to membership page
        if (subscribedStatus == 'false') {
            window.location = window.location.origin + '/membership';
            return false;
        }
    });

    const navigate = useNavigate();
 
  
    const clickOnRow = (index) => {
        if (selectedRow === index) {
            setSelectedRow(false);
        } else {
            setSelectedRow(index);
        }
    };

    const getTrainingSession = () => {
        setLoading(true);
        axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token")
            },
            url: `${BASE_URL}/user/training/session`, //your url
            method: 'get',
        }).then((res) => {
            console.log("respo : ",res?.data?.data)
            setBookedTrainningSession(res?.data?.data);
            setLoading(false);
        });
    };
    const fetchSessionPlan=async ()=>{
        try {
            const responce=await axios.get(`${BASE_URL}/admin/allTraining`,{
                headers: {
                    "x-access-token": authStorage.getItem("auth-token"),
            }});
        
            setChrgeData(responce?.data?.data);
        } catch (error) {
            console.log("Error fetching chargeData : ",error);
        }
    }
    const amount= (price)=>{
        setShowPaymentForm(price)
    }
    const amountsess= (ses)=>{
        setSesno(ses);
    }
    useEffect(() => {
        getTrainingSession();
        fetchSessionPlan();
    }, []);

    useEffect(() => {
        let totalTrainingSession = 0;
        let bookedTrainingSession = 0;
        bookedTrainningSession?.map((data) => {
            totalTrainingSession = totalTrainingSession + parseInt(data?.sessions);
            // bookedTrainingSession = bookedTrainingSession + data?.sessionTiming?.length;
            data?.sessionTiming?.filter((timing) => !timing.cancelByAdmin).forEach(() => {
                bookedTrainingSession++;
              });
        });
        setTraningSessionDetail({
            total: totalTrainingSession,
            booked: bookedTrainingSession
        });
    }, [bookedTrainningSession]);

    const handlePayment = async () => {
        try {
            const stripe = await stripePromise;

            // Call backend with POST & correct body
            const res = await axios.post(
                `${BASE_URL}/auth/create/onetime/app-payment-intent`,
                {
                    price: selectedPrice,
                    sesno: selectedSession,
                    title: selectedTitle
                },
                {
                    headers: {
                        "x-access-token": authStorage.getItem("auth-token")
                    }
                }
            );

            

            const sessionId = res?.data?.sessionId;
            if (!sessionId) {
                console.error("No session ID returned from backend");
                return;
            }

            authStorage.removeItem("training_session_id");

            authStorage.setItem("training_session_id", sessionId);
            // Redirect to Stripe Checkout
            const { error } = await stripe.redirectToCheckout({ sessionId });
            if (error) {
                console.error("Stripe redirect error:", error);
            }

        } catch (err) {
            console.error("Stripe checkout error:", err);
        }
    };


    return (
        <>
            <div className="min-h-screen md:mx-10 md:h-auto px-4 sm:px-0">
                <div className="py-8 lg:py-10">
                    <div className="mobile-wrapper">
                        <div className="header">
                            <span className="back-btn">
                            {/* <a href="#">
                                <img src={arrowBack} alt="Icon" />
                            </a> */}
                            </span>
                            <div className="header-title">Training</div>
                        </div>

                        {showPaymentForm ? (
                            <div>redirect to stripe...</div>
                        ) : (
                            <div>
                                <div className="">
                                    <div className="overview-component">
                                        <div className="icon-box">
                                            <img src={videoOctagon} alt="Icon" />
                                        </div>
                                        <h1>Video Training</h1>
                                        <p>
                                            CFT offers one-to-one online training sessions for individuals and
                                            corporate users seeking personalized guidance.
                                        </p>
                                        <p>
                                            These sessions are conducted outside the app via platforms such as
                                            Microsoft Teams, Google Meet, or Zoom.
                                        </p>
                                        <p>
                                            This service is not part of the mobile app, and no in-app purchases are
                                            required or offered.
                                        </p>
                                        <p>Only minimal exercise equipment is needed.</p>
                                    </div>
                                    <div className="col-box-component">
                                        {chrgeData?.map((chrgeDat) => 
                                            chrgeDat.isActive && (
                                                <>

                                                <div
                                                    key={chrgeDat.id}
                                                    onClick={() => {
                                                    // update footer state
                                                    setSelectedPrice(chrgeDat?.price);
                                                    setSelectedSession(chrgeDat?.session);
                                                    setSelectedTitle(chrgeDat?.title);
                                                    }}
                                                    className="col-box"
                                                >
                                                    <div className="title">{chrgeDat?.title}</div>
                                                    <p>{chrgeDat?.description}</p>
                                                    <div className="price-box-component">
                                                    <div className="price-box">
                                                        <span className="price">${chrgeDat?.price}</span>/
                                                        {chrgeDat?.session} SESSION
                                                    </div>
                                                    </div>
                                                </div>
                                                </>
                                            )
                                        )}
                                    </div>
                                </div>
                                <div className="footer-component">
                                    <div className="">
                                        <div className="price-box-component">
                                        <div>
                                            <div className="price-box">
                                            <span className="price">
                                                ${selectedPrice ?? "--"}
                                            </span>
                                            /{selectedSession ?? "--"} SESSION
                                            </div>
                                            {selectedTitle && <span className="pro-txt">{selectedTitle}</span>}
                                        </div>
                                        <button
                                            onClick={() => {
                                            amount(selectedPrice);
                                            amountsess(selectedSession);
                                            handlePayment();
                                            }}
                                            className="continue-btn"
                                        >
                                            Continue
                                        </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div >
        </>
    )
}
export default PersonalAppTraining;
